import SelectFormField from '@shared/components/form/select-form-field';
import { useMemo } from 'react';
import { BUSINESS_TRAVEL_METHODOLOGY, METHODOLOGY_OPTIONS } from './constants';

interface MethodologySelectProps {
  className?: string;
  disabled?: boolean;
  disableTotalEmissions?: boolean;
  onMethodologyChange?: (value: string) => void;
}

const SECR_INCOMPATIBLE_DESCRIPTION = 'Not compatible with SECR reporting';

export default function MethodologySelect({
  className,
  disabled,
  disableTotalEmissions,
  onMethodologyChange,
}: MethodologySelectProps) {
  const options = useMemo(
    () =>
      METHODOLOGY_OPTIONS.map((option) =>
        disableTotalEmissions &&
        option.value === BUSINESS_TRAVEL_METHODOLOGY.totalEmissions
          ? {
              ...option,
              disabled: true,
              description: SECR_INCOMPATIBLE_DESCRIPTION,
            }
          : option
      ),
    [disableTotalEmissions]
  );

  return (
    <SelectFormField
      name="methodology"
      label="Methodology"
      options={options}
      showDescription
      showIcon
      disabled={disabled}
      handleSelect={onMethodologyChange}
      className={className}
    />
  );
}
